import {Component, Host, h, Prop, Listen, Event, EventEmitter} from '@stencil/core';
import { WishlistEvent } from './WishlistEvent';
import {$$$} from "../../../utils/utils";

@Component({
  tag: 'lilu-wishlist',
  styleUrl: 'lilu-wishlist.scss',
  shadow: true,
})
export class LiluWishlist {

  // Propertie
  @Prop() isWishlist = false;
  @Prop() size = 'size-sm';
  @Prop() productId: string;

  // Event
  @Event()
  wishlisted: EventEmitter<WishlistEvent>;

  // listener
  @Listen('click')
  handelClick() {
    this.isWishlist = !this.isWishlist;
    this.wishlisted.emit({ isWishlist: this.isWishlist });

    if(this.isWishlist) {
      $$$('lilu-header-wishlist')[0].addToWishlist(this.productId);
    } else {
      $$$('lilu-header-wishlist')[0].removeFromWishlist(this.productId);
    }
  }

  render() {
    return (
      <Host>
        <span class={`wishlist ${this.size}`}>
          <lilu-icon color="nero" type={`${this.isWishlist ? 'icon-heart-02 ' : 'icon-heart'}`}></lilu-icon>
        </span>
      </Host>
    );
  }
}
